import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Rating,
} from "@mui/material";
import React from "react";

const ReviewBox = ({ data }) => {
  return (
    <List
      sx={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }}
      disablePadding
    >
      {data.map((val, index) => (
        <ListItem key={index} divider>
          <ListItemAvatar>
            <Avatar src={val?.user?.profileImg} />
          </ListItemAvatar>
          <ListItemText
            primary={`${val?.user?.firstname} ${val?.user?.lastname}`}
            secondary={val?.comment}
          />
          <Rating
            precision={0.5}
            value={Number(val?.rating)}
            readOnly
            sx={{
              fontSize: {
                xs: "1.2rem", // small size for extra-small screens
                sm: "1.6rem", // medium size for medium screens and up
              },
            }}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default ReviewBox;
